import BasicRouteBuilder from 'Shared/utils/routeBuilder'

import { Routes } from './constants'

class CustomerRouteBuilder extends BasicRouteBuilder {
	// INJECT_FROM_PLOP_TABLELIST

	get purchaseOrder() {
		this.route += Routes.PURCHASE_ORDER
		return this
	}

	get siteDocument() {
		this.route += Routes.SITE_DOCUMENT
		return this
	}

	get backupDocument() {
		this.route += Routes.BACKUP_DOCUMENT
		return this
	}

	get customerInvoice() {
		this.route += Routes.CUSTOMER_INVOICE
		return this
	}

	get biohazardousManifest() {
		this.route += Routes.BIOHAZARDOUS_MANIFEST
		return this
	}

	get wastestream() {
		this.route += Routes.WASTESTREAM
		return this
	}

	get dashboard() {
		this.route += Routes.DASHBOARD
		return this
	}

	get order() {
		this.route += Routes.ORDER
		return this
	}

	get report() {
		this.route += Routes.REPORT
		return this
	}

	get companyCategory() {
		this.route += Routes.COMPANY_CATEGORIES
		return this
	}

	get accountCategory() {
		this.route += Routes.ACCOUNT_CATEGORIES
		return this
	}

	get treatmentCategory() {
		this.route += Routes.TREATMENT_CATEGORIES
		return this
	}

	get treatmentMethod() {
		this.route += Routes.TREATMENT_METHODS
		return this
	}

	get manifest() {
		this.route += Routes.MANIFESTS
		return this
	}

	get mou() {
		this.route += Routes.MOU
		return this
	}

	get profile() {
		this.route += Routes.PROFILE
		return this
	}

	get analytic() {
		this.route += Routes.ANALYTIC
		return this
	}

	get helpCenter() {
		this.route += Routes.HELP_CENTER
		return this
	}

	get registrationDocument() {
		this.route += Routes.REGISTRATION_DOCUMENT
		return this
	}

	get metricByPeriods() {
		this.route += Routes.STORE_METRIC_BY_PERIODS
		return this
	}

	get location() {
		this.route += Routes.LOCATION
		return this
	}

	get audit() {
		this.route += Routes.AUDIT
		return this
	}

	get serviceLocation() {
		this.route += Routes.SERVICE_LOCATION
		return this
	}
}

const RouteBuilder = new CustomerRouteBuilder()

export default RouteBuilder
